import type { GetInvitationsResponse } from '@vy/api-definition';
import { GetInvitationsResponseSchema } from '@vy/api-definition';
import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';
import type { CustomUseQueryOptions } from './requests-types/custom-use-query-options';

export function useInvitations(options?: CustomUseQueryOptions<GetInvitationsResponse>) {
  return useQuery({
    queryKey: queryKeys.invitations(),
    queryFn: async () => {
      const api = getPrivateApi();

      const invitationsResponse = await api.getInvitations();

      return GetInvitationsResponseSchema.parse(invitationsResponse);
    },
    ...options,
  });
}
